import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

// Single-message toast queue. Components dispatch feedBack* actions; the FeedbackToast layout
// component (Task 30) subscribes and renders. Auto-clear timer lives in the component, not here.

export type FeedbackType = 'error' | 'success' | 'warning' | 'info';

export interface FeedbackState {
  type: FeedbackType | null;
  msg: string | null;
}

const initialState: FeedbackState = { type: null, msg: null };

const slice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    feedBackError(state, action: PayloadAction<{ msg: string }>) {
      state.type = 'error';
      state.msg = action.payload.msg;
    },
    feedBackSuccess(state, action: PayloadAction<{ msg: string }>) {
      state.type = 'success';
      state.msg = action.payload.msg;
    },
    feedBackWarning(state, action: PayloadAction<{ msg: string }>) {
      state.type = 'warning';
      state.msg = action.payload.msg;
    },
    // CORP-8467: aviso de operação em andamento ("Baixando arquivo"), igual ao que o
    // `queueManager` do Angular mostra enquanto o arquivo é gerado. Fica na tela até o
    // feedBackSuccess/feedBackError da mesma operação tomar o lugar dele — a fila é de uma
    // mensagem só, então os dois nunca aparecem sobrepostos.
    feedBackInfo(state, action: PayloadAction<{ msg: string }>) {
      state.type = 'info';
      state.msg = action.payload.msg;
    },
    feedBackClear() {
      return initialState;
    },
  },
});

export const { feedBackError, feedBackSuccess, feedBackWarning, feedBackInfo, feedBackClear } =
  slice.actions;
export default slice.reducer;
